import { render, staticRenderFns } from "./BaseInputCheckbox.vue?vue&type=template&id=3c8b1088&"
import script from "./BaseInputCheckbox.vue?vue&type=script&lang=ts&"
export * from "./BaseInputCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports